"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Card, CardContent } from "@/components/ui/card";
import { WP_Query } from "@/integrations/wordpress/wp_query";
import { AddToCartButton, EcommerceProductsProvider, useEcommerceProducts } from "@/integrations/wordpress/WordPressEcommerceProductsProvider";
function DestaquesGridConsumer() {
  const {
    products,
    loading,
    error
  } = useEcommerceProducts();
  if (loading) {
    return <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 md:grid-cols-4">
        {[...Array(4)].map((_, i) => <div key={i} data-index={i} className="h-[340px] animate-pulse rounded-md bg-muted/50" />)}
      </div>;
  }
  if (error) {
    return <div className="py-12 text-center text-sm text-muted-foreground">
        Unable to load our seasonal blooms at this time.
      </div>;
  }
  if (products.length === 0) {
    return <div className="py-12 text-center text-sm text-muted-foreground">
        No garden-fresh arrangements found.
      </div>;
  }
  return <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 md:grid-cols-4">
      {products.map((product, i) => <Card key={product.id} data-index={i} className="group flex flex-col overflow-hidden border-none bg-transparent pt-0 shadow-sm transition-all duration-500 hover:shadow-lg">
          <Link to={product.link} className="relative aspect-square overflow-hidden bg-muted/10">
            {product.featured_image_url ? <img src={product.featured_image_url} alt={product.title} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110" loading="lazy" /> : <div className="flex h-full w-full items-center justify-center bg-muted/20">
                <span className="text-xs text-muted-foreground font-default">Petal Studio</span>
              </div>}
          </Link>
          <CardContent className="flex flex-grow flex-col justify-between gap-4 p-4">
            <div className="space-y-1.5">
              <Link to={product.link}>
                <h3 className="font-serif line-clamp-2 text-lg font-medium leading-tight text-foreground transition-colors hover:text-primary">
                  {product.title}
                </h3>
              </Link>
              <div className="font-default text-base font-normal text-muted-foreground">
                ${product.price?.toFixed(2) || "0.00"}
              </div>
            </div>
            <div className="mt-auto pt-2 opacity-0 transition-opacity duration-300 group-hover:opacity-100">
              <AddToCartButton productId={product.id} variant="default" size="sm" className="w-full" buttonClassName="w-full bg-white/40 backdrop-blur-md text-primary border border-white/20 shadow-md hover:bg-white/60 rounded-md" text="Quick Add" showQuantity={false} />
            </div>
          </CardContent>
        </Card>)}
    </div>;
}
const wp_query_params = {
  per_page: 4,
  orderby: "date",
  order: "desc"
};
const wp_query = new WP_Query(wp_query_params);
export default function DestaquesDaSemana() {
  return <section data-section-id="224894" id="fresh-from-the-garden" className="bg-background text-foreground py-16 md:py-24">
      <div className="container mx-auto px-4 md:px-6">
        <div className="mb-8 flex items-end justify-between gap-4">
          <div className="space-y-1">
            <h2 className="font-default text-3xl font-bold tracking-tight text-foreground md:text-4xl">
              Fresh from the Garden
            </h2>
            <p className="text-base text-muted-foreground font-default">
              Hand-picked seasonal arrangements harvested this morning.
            </p>
          </div>
          <Link to="/ShopPage" className="hidden text-sm font-medium text-primary hover:underline sm:block font-default tracking-wide">
            Explore the Shop &rarr;
          </Link>
        </div>
        
        <EcommerceProductsProvider wp_query={{
        per_page: 4,
        orderby: "date",
        order: "desc"
      }}>
          <DestaquesGridConsumer />
        </EcommerceProductsProvider>

        <div className="mt-8 flex justify-center sm:hidden">
          <Link to="/ShopPage" className="text-sm font-medium text-primary hover:underline font-default">
            View all arrangements &rarr;
          </Link>
        </div>
      </div>
    </section>;
}